<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-layout>
                    <v-flex xs12>
                        <v-alert outline :value="true" type="success">
                            Order has been sent.
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-card>                   
        </v-flex>
    </v-layout>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';
import util from '@/services/util';

export default {
    components: {
        ErrorAlert
    },
    props: [
        'loading',
        'confirming',
        'confirmError'
    ],
    data() {
        return {
            pagination: {
                sortBy: "Product.Supplier.Name"
            },
            headers: [
                {
                    text: "Category",
                    value: "Category.Name",
                    width: "25%"
                },
                {
                    text: "Product",
                    value: "Product.Name",
                    width: "25%"
                },
                {
                    text: "Supplier",
                    value: "Product.Supplier.Name",
                    width: "25%"
                },
                {
                    text: "Quantity",
                    value: "Quantity",
                    width: "15%"
                },
                {
                    text: "", // edit button
                    width: "10%"
                }
            ]
        };
    },
    computed: {
        order(){
            return this.$store.state.placeOrderStore.order;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID)).sort(util.sortByName);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active && auth.hasAccessToDepartment(d.ID)).sort(util.sortByName);
        },
        departmentsInSelectedStore(){
            let selectedStoreID = this.order.StoreID;

            return this.departments.filter(d => {
                if(!selectedStoreID){
                    return false;
                }

                let selectedStore = this.stores.find(s => s.ID == selectedStoreID);
                if(!selectedStore.DepartmentIDs){
                    return false;
                }
                
                let selectedStoreContainsDepartment = selectedStore.DepartmentIDs.split(",").some(dID => dID == d.ID);
                if(!selectedStoreContainsDepartment){
                    return false;
                }

                return true;
            });
        },
        products() {
            return this.$store.state.productStore.products.filter(p => p.Active).sort(util.sortByName);
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active).sort(util.sortByName);
        }
    },
    methods: {
        confirmOrder() {
            this.$emit("onConfirm");
        }
    }
};
</script>

<style>

</style>
